import { render, staticRenderFns } from "./ConfigureQuestion.vue?vue&type=template&id=d421c16e&"
import script from "./ConfigureQuestion.vue?vue&type=script&lang=ts&"
export * from "./ConfigureQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d421c16e')) {
      api.createRecord('d421c16e', component.options)
    } else {
      api.reload('d421c16e', component.options)
    }
    module.hot.accept("./ConfigureQuestion.vue?vue&type=template&id=d421c16e&", function () {
      api.rerender('d421c16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/ConfigureQuestion.vue"
export default component.exports